import React, { Component } from 'react';

// import { API, Auth } from "aws-amplify";

// import { Layout, Menu, Breadcrumb, Icon } from 'antd';
import { Card } from 'antd';
import { PageHeader } from 'antd';
// import { Button } from 'antd';

import ExerciseListPageComponent from '../../../components/pages/dashboard/exercises/ExerciseListPageComponent';

// const { Header, Content, Footer, Sider } = Layout;
// const { SubMenu } = Menu;

class ExerciseListPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    return (

      <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
        <PageHeader
          style={{
            paddingLeft: 0,
            borderBottom: '1px solid rgb(235, 237, 240)',
            marginBottom: 16
          }}
          title="Exercise List"
        />
        <Card
          style={{ minHeight: 360 }}
          title="View a list of current exercises"
        >
          <div style={{ paddingTop: 24 }}>
            <ExerciseListPageComponent />
          </div>
        </Card>
      </div>


    );
  }
}

export default ExerciseListPage;
